import type { FirebaseDatabaseManager } from '@app/services/FirebaseDatabaseManager'

import { sink } from '@app/utils/sink'

import { createThunk } from '@app/store/thunk'

export function getFirebaseDatabaseManager() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<Promise<FirebaseDatabaseManager | null>>(FirebaseDatabaseManagerSymbol))
}
export function setFirebaseDatabaseManager(value: Promise<FirebaseDatabaseManager | null>) {
  sink(value)
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(FirebaseDatabaseManagerSymbol, value))
}

const FirebaseDatabaseManagerSymbol = Symbol('FirebaseDatabaseManager')
